import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faBell,
  faBellSlash,
  faBold,
  faBolt,
  faBookmark,
  faCalendarDays,
  faCamera,
  faCheck,
  faMobileScreenButton,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleHalfStroke,
  faCirclePlus,
  faClock,
  faCode,
  faComments,
  faAddressCard,
  faTriangleExclamation,
  faCopy,
  faDesktop,
  faDownload,
  faEllipsis,
  faEraser,
  faEye,
  faEyeSlash,
  faFaceSmile,
  faMugHot,
  faFile,
  faFileWaveform,
  faFileLines,
  faGear,
  faGears,
  faGripVertical,
  faHand,
  faHashtag,
  faHeadphones,
  faImage,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMicrophone,
  faMicrophoneSlash,
  faMoon,
  faPaperclip,
  faPaperPlane,
  faPause,
  faPen,
  faNoteSticky,
  faPenToSquare,
  faPhone,
  faAddressBook,
  faGrip,
  faPhoneSlash,
  faRightLeft,
  faPlay,
  faPowerOff,
  faReply,
  faShareFromSquare,
  faRightFromBracket,
  faQuoteRight,
  faStar,
  faStrikethrough,
  faUnderline,
  faSun,
  faThumbtack,
  faTrash,
  faUserPlus,
  faUserShield,
  faUsers,
  faVideo,
  faVideoSlash,
  faXmark,
  faWandMagicSparkles,
  faWrench,
  faVolumeHigh,
  faPalette,
  faCircleUser,
  faBoxArchive,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Ikonkeszlet.
 *
 * **Miert nem emoji?** Az emoji betutipus-fuggo: mas alakot rajzol Windowson,
 * Macen es Linuxon, nehany jelre pedig (pl. a "kepernyo") egyaltalan nincs
 * rajz - ott ures negyzet latszik. Egy felulet-ikon nem lehet a rendszer
 * betukeszletenek fuggvenye.
 *
 * **Miert FontAwesome?** Egyetlen, kovetkezetes vonalvastagsagu es optikai
 * sulyu keszlet. Az emojik keverese sajat rajzokkal pont azt a "ki-mit-talalt"
 * hatast adta, amit el akarunk kerulni.
 *
 * A neveket MAGYARUL adjuk meg: a hivo helyen a `<Icon name="beallitasok" />`
 * onmagat magyarazza, a `faGear` nem.
 */
const ICONS = {
  beallitasok: faGear,
  fogantyu: faGripVertical,
  letoltes: faDownload,
  mutat: faEye,
  rejt: faEyeSlash,
  temaRendszer: faCircleHalfStroke,
  tovabbitas: faShareFromSquare,
  kikapcsolas: faPowerOff,
  bezaras: faXmark,
  csatorna: faHashtag,
  /** Beszelgetes (pl. az oleles chatje). */
  chat: faComments,
  /** Egy ugyfel adatlapja. */
  ugyfel: faAddressCard,
  csatolmany: faPaperclip,
  emoji: faFaceSmile,
  ertesites: faBell,
  ertesitesNema: faBellSlash,
  fajl: faFile,
  /** Canvas: a csatorna kozos jegyzetlapja. */
  canvas: faFileLines,
  /** Sajat jegyzetek: a csak nekem lathato beszelgetes. */
  jegyzet: faNoteSticky,
  atirat: faFileWaveform,
  figyelmeztetes: faTriangleExclamation,
  huddle: faHeadphones,
  /** Kezemeles az olelesben. */
  kez: faHand,
  kave: faMugHot,
  kamera: faVideo,
  fenykep: faCamera,
  megosztas: faArrowUpFromBracket,
  telepites: faMobileScreenButton,
  kameraKi: faVideoSlash,
  kep: faImage,
  keres: faMagnifyingGlass,
  kepernyo: faDesktop,
  kijelentkezes: faRightFromBracket,
  kilepes: faPhoneSlash,
  telefon: faPhone,
  /** Telefonos csatorna: a korabbi hivott es hivo szamok, nevvel. */
  cimjegyzek: faAddressBook,
  /** Telefonos csatorna: szam beirasa es hivasa. */
  tarcsazo: faGrip,
  atadas: faRightLeft,
  kituzes: faThumbtack,
  kuldes: faPaperPlane,
  lakat: faLock,
  masolas: faCopy,
  mentes: faBookmark,
  mikrofon: faMicrophone,
  mikrofonNema: faMicrophoneSlash,
  nagyitas: faMagnifyingGlassPlus,
  kicsinyites: faMagnifyingGlassMinus,
  megnyitas: faArrowUpRightFromSquare,
  meghivas: faUserPlus,
  pipa: faCheck,
  szunet: faPause,
  folytatas: faPlay,
  rajz: faPen,
  radir: faEraser,
  szerkesztes: faPenToSquare,
  szerkesztesTobb: faEllipsis,
  temaSotet: faMoon,
  temaVilagos: faSun,
  torles: faTrash,
  ora: faClock,
  naptar: faCalendarDays,
  tagok: faUsers,
  admin: faUserShield,
  uj: faCirclePlus,
  valasz: faReply,
  csillag: faStar,
  felkover: faBold,
  dolt: faItalic,
  alahuzott: faUnderline,
  athuzott: faStrikethrough,
  kod: faCode,
  idezet: faQuoteRight,
  listaPontos: faListUl,
  listaSzamozott: faListOl,
  link: faLink,
  le: faChevronDown,
  balra: faChevronLeft,
  jobbra: faChevronRight,
  nyilFel: faArrowUp,
  nyilLe: faArrowDown,
  nyilBalra: faArrowLeft,
  nyilJobbra: faArrowRight,
  /** Ujdonsagok: uj funkcio. */
  ujdonsag: faWandMagicSparkles,
  /** Ujdonsagok: fejlesztes. */
  fejlesztes: faBolt,
  /** Ujdonsagok: javitas. */
  javitas: faWrench,
  /** Ujdonsagok: hatterben tortent valtozas. */
  hatter: faGears,
  /** Beallitasok fulei. */
  hang: faVolumeHigh,
  paletta: faPalette,
  fiok: faCircleUser,
  archivum: faBoxArchive,
} satisfies Record<string, IconDefinition>;

export type IconName = keyof typeof ICONS;

/**
 * Meretek.
 *
 * Az ikon a SZOVEGHEZ igazodik (`em`), nem fix pixelhez: igy egyutt no a
 * betumerettel, es nem kell minden helyen kulon hangolni.
 */
const SIZES = {
  sm: '0.95em',
  md: '1.05em',
  lg: '1.3em',
  xl: '1.6em',
} as const;

export function Icon({
  name,
  size = 'md',
  className = '',
  label,
}: {
  name: IconName;
  size?: keyof typeof SIZES;
  className?: string;
  /**
   * Ha az ikon MAGA a jelentes (nincs mellette szoveg), add meg.
   * Enelkul a kepernyoolvaso csak egy nevtelen gombot talal.
   */
  label?: string;
}) {
  return (
    <FontAwesomeIcon
      icon={ICONS[name]}
      style={{ fontSize: SIZES[size] }}
      className={className}
      aria-hidden={label ? undefined : true}
      {...(label ? { role: 'img', 'aria-label': label } : {})}
    />
  );
}
